<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name" disabled)
          v-col(cols="12")
            BaseTextField(rules="required|numeric|min_value:0|max_value:100" v-model="form.fee", :label="translations.label.fee")
          v-col(cols="12")
            BaseChipSelectField(rules="required", :items="jurisdictions" v-model="form.jurisdiction", :label="translations.label.jurisdiction" disabled)
          v-col(cols="12")
            p {{ translations.memberInfo }}
            ValidationProvider(rules="required" v-slot="{ errors }")
              v-select(:items="operatorsList" item-text="text" item-value="value" return-object chips multiple v-model="form.members", :error="errors.length > 0" @change="checkInitalValues")
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                  | {{ translations.label.members }}
              span.red--text.text--accent-2(v-if="errors.length > 0")
                v-icon(color="red accent-2") mdi-alert
                |  {{ errors[0] }}
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(
                  color="primary"
                  type="submit"
                  :loading="loadingEdit"
                  ) {{ translations.buttons.edit }}

</template>

<script>

  export default {
    name: "NetworkEdit",
    props: {
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      network:{
        type: Object,
        default: function(){
          return {}
        }
      },
      operatorsList: {
        type: Array,
        default: function(){
          return []
        }
      },
      jurisdictions: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      form:{
        name: '',
        members: [],
        fee: '0',
        jurisdiction: '',
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editNetwork.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editNetwork.state;
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200) {
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          _id: this.network._id,
          data: {
            name: this.form.name,
            members: this.form.members.map((member) => {
                return member.value
              }),
            fee: parseInt(this.form.fee),
            jurisdiction: this.form.jurisdiction.map((item)=>{return item.value})
          },
        };
        this.$store.dispatch('editNetwork', formSend);
      },
      setFields(){
        this.form.name = this.network.name;
        this.form.fee = this.network.fee.toString();
        this.form.jurisdiction = this.network.jurisdiction;
        this.form.members = this.network.members;
      },
      checkInitalValues(){
        const that = this;
        let elem;
        that.network.members.forEach((netMem)=>{
          elem = that.form.members.filter((formMem)=>{
            return formMem.value == netMem.value;
          });
          if(elem.length == 0){
            that.form.members.push(netMem);
          }
        });
      },
    }
  }
</script>

<style lang="sass">
</style>